import { Typography } from "@mui/joy";
import type { SxProps } from "@mui/joy/styles/types";
import { useScramble } from "use-scramble";

import { formatPrice } from "~/common/utils/format-price";

interface ScramblePriceProps {
  price: number;
  sx?: SxProps;
}

export const ScramblePrice = ({ price, sx }: ScramblePriceProps) => {
  const { ref } = useScramble({
    text: `₴${formatPrice(price)}`,
    speed: 0.5,
    tick: 1,
    step: 1,
    scramble: 5,
    seed: 1,
    range: [48, 57], // 0-9 digits only
    ignore: ["₴", " "],
  });

  return (
    <Typography
      ref={ref}
      component="span"
      sx={{
        fontSize: {
          xs: "2rem",
          sm: "2.5rem",
          md: "2.75rem",
          lg: "3rem",
        },
        fontWeight: 600,
        lineHeight: 1.15,
        letterSpacing: "-0.02em",
        ...sx,
      }}
    />
  );
};
